import React, { FunctionComponent } from 'react';
import { ForgeIcon, ForgeIconButton, ForgeTooltip } from '@tylertech/forge-react';

import { I18n } from 'common/i18n';
import { canSeeCreateAssetsDialog } from '../../utils/site_chrome_rights';

interface CreateAssetButtonProps {
  openDialog: () => void;
}
const CreateAssetButton: FunctionComponent<CreateAssetButtonProps> = ({ openDialog }) => {
  const scope = 'shared.site_chrome.forge_omnibar.navigation';

  if (!canSeeCreateAssetsDialog()) {
    return null;
  }

  return (
    <>
      <ForgeIconButton
        slot="action"
        id="create-assets"
        aria-label="Create Assets"
        className="tyler-icons"
        onClick={openDialog}
      >
        <ForgeIcon name="add_circle_outline" external external-type="standard" />
      </ForgeIconButton>
      <ForgeTooltip placement={'bottom'}>{I18n.t(`${scope}.create`)}</ForgeTooltip>
    </>
  );
};

export default CreateAssetButton;
